// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SZO7p5h94ET2Ye3NVPBK{justify-content:space-between;display:flex}.SZO7p5h94ET2Ye3NVPBK .lYisi7h4QO62Ipue_TUs{flex-direction:column;gap:4px;padding-top:16px;padding-bottom:16px;display:flex}.SZO7p5h94ET2Ye3NVPBK .lYisi7h4QO62Ipue_TUs .S6nmcl2eO4EIC3hqyV2o{gap:4px;display:flex}.SZO7p5h94ET2Ye3NVPBK .dVvBZtOR16kFw1Fmp_Q6{padding-top:24px;padding-left:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleCard": `SZO7p5h94ET2Ye3NVPBK`,
	"left": `lYisi7h4QO62Ipue_TUs`,
	"row": `S6nmcl2eO4EIC3hqyV2o`,
	"right": `dVvBZtOR16kFw1Fmp_Q6`
};
export default ___CSS_LOADER_EXPORT___;
